import { ColumnOrderState } from '@tanstack/react-table';

// A saved view only lists the columns that existed when it was saved, and
// react-table renders anything the order doesn't mention after everything it
// does. Every other reader of the order has to agree with that, or a field
// added since the view was saved reads as first in the fields sidebar while it
// sits last in the table - and dragging it moves whichever column is at the end
// instead, because arrayMove takes indexOf's -1 as "the last one".

// A column can name the one it belongs beside (placeAfter, keyed by column id)
// and then it goes there instead of last. Only ids the order does not already
// carry are placed, so a position the user has dragged is never moved.
export const withMissingColumnsAtEnd = (
  order: ColumnOrderState,
  availableColumnIds: Array<string>,
  placeAfter: Record<string, string> = {},
): ColumnOrderState => {
  const missing = availableColumnIds.filter((id) => !order.includes(id));
  if (missing.length === 0) {
    return order;
  }

  const merged = [...order];
  missing.forEach((id) => {
    const anchor = placeAfter[id] ? merged.indexOf(placeAfter[id]) : -1;
    if (anchor === -1) {
      merged.push(id);
      return;
    }
    merged.splice(anchor + 1, 0, id);
  });

  return merged;
};

export const getColumnOrderIndex = (order: ColumnOrderState, id: string) => {
  const index = order.indexOf(id);

  return index === -1 ? Number.MAX_SAFE_INTEGER : index;
};
